@if (current) {
  <figure class="carousel" [style.--carousel-aspect]="aspectRatio" (mouseenter)="pause()" (mouseleave)="resume()">
    <div class="carousel__frame">
      <img
        [src]="current.src"
        [alt]="current.alt + (hasMany ? ' (photo ' + (index() + 1) + ' of ' + slides.length + ')' : '')"
        [class.fading]="fading()"
        [attr.loading]="eager ? 'eager' : 'lazy'"
        [attr.fetchpriority]="eager ? 'high' : null">
      @if (hasMany) {
        <button type="button" class="carousel__btn carousel__btn--prev" (click)="manual(-1)" aria-label="Previous photo">&#10094;</button>
        <button type="button" class="carousel__btn carousel__btn--next" (click)="manual(1)" aria-label="Next photo">&#10095;</button>
      }
    </div>
    @if (hasCaptions) {
      <figcaption class="carousel__captions">
        @for (slide of slides; track slide.src; let i = $index) {
          <span class="carousel__caption" [class.is-active]="i === index()" [attr.aria-hidden]="i !== index()">{{ slide.caption }}</span>
        }
      </figcaption>
    }
  </figure>
}
